import { useCallback } from "react";
import { type QueryClient, useQueryClient } from "@tanstack/react-query";
import {
	createVehicleQueryOptions,
	useVehicleQueryOptions,
} from "../../query-keys";
import type { Platform } from "@/types/platform.types";

/**
 * Hook version for use in components
 */
export function usePrefetchVehicleClientPreferences() {
	const queryClient = useQueryClient();
	const vehicleQueryOptions = useVehicleQueryOptions();

	return useCallback(
		(vehicleId: string) =>
			queryClient.prefetchQuery(
				vehicleQueryOptions.clientPreferences(vehicleId)
			),
		[queryClient, vehicleQueryOptions]
	);
}

/**
 * Static function for route loaders (outside React context)
 * Requires explicit platform parameter
 */
export async function prefetchVehicleClientPreferences({
	queryClient,
	platform,
	vehicleId,
}: {
	queryClient: QueryClient;
	platform: Platform;
	vehicleId: string;
}) {
	const vehicleQueryOptions = createVehicleQueryOptions(platform);
	return queryClient.prefetchQuery(
		vehicleQueryOptions.clientPreferences(vehicleId)
	);
}
